import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";
import Title from "@streeteasy/design-system/deprecated/Title";

const MobileHeaderTitle = styled(Title).attrs({ type: "secondary" })`
  color: ${colorPalette.pureWhite};
  font-size: 18px;
  top: 0;
  left: 50px;
  right: 50px;
  position: fixed;
  z-index: 999999;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Bold = styled.span`
  font-weight: bold;
`;

MobileHeaderTitle.displayName = "MobileHeaderTitle";
Bold.displayName = "Bold";

export { MobileHeaderTitle, Bold };
